import React, { useEffect, useRef } from 'react';
import { auth } from '../../../api/firebase';

const styles = {
  message: {
    marginBottom: '5px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
  },
  sent: {
    backgroundColor: '#266162',
    color: 'white',
    borderRadius: '10px 0px 10px 10px',
    alignSelf: 'flex-end',
  },
  received: {
    backgroundColor: '#e5e5ea',
    color: 'black',
    borderRadius: '0px 10px 10px 10px',
    alignSelf: 'flex-start',
  },
  messageContent: {
    padding: '0px 12px',
    borderRadius: '12px',
    maxWidth: '65%', // Adjust as needed
  },
  name: {
    color: 'gray',
    fontSize: '12px',
    marginBottom: '0px',
  },
  time: {
    color: 'gray',
    fontSize: '12px',
    marginBottom: '0px',
    fontWeight:'bold',
  },
};

const Message = ({ message, rowData }) => {

  const lastMsgRef = useRef(null);
  const userId = rowData.rowData.id;
  console.log(message, userId);
  console.log(auth.currentUser.uid )
  useEffect(() => {
			scrollToLastMsg();
	}, []);

  const scrollToLastMsg = () => {
		lastMsgRef.current.scrollIntoView();
	};

  const messageClass =
    message.uid === auth.currentUser.uid ? styles.sent : styles.received;

  return (
    <div style={{ ...styles.container, ...styles.message }}>
      <div style={{ ...styles.messageContent, ...messageClass }}>
        <p style={styles.name} ref={lastMsgRef}>{message.name}</p>
        <span>{message.text}</span>{" "}
        <span style={styles.time}>{message.time}</span>
      </div>
    </div>
  );
};

export default Message;
